import moment from "moment";

// Native date inputs emit an empty value while a date is being edited.
export const parseScheduleDate = (value) => {
  const date = moment(value, "YYYY-MM-DD", true);
  return date.isValid() ? date.toDate() : null;
};

export const matchesLessonFilters = (event, filters, filterTeachers) => {
  const rawCentre = event.centre || "";
  const centre = /^online-onsite$/i.test(rawCentre) ? "Online-onsite"
    : /^online-offsite$/i.test(rawCentre) ? "Online-offsite" : rawCentre;
  const centreFilters = filters?.centreFilter || {};
  // Old records used Online before onsite/offsite were recorded separately.
  const matchesCentre = centre === "Online"
    ? centreFilters["Online-onsite"] || centreFilters["Online-offsite"]
    : centreFilters[centre];
  const teacherId = event.teacher?.id ?? "unassigned";
  return Boolean(matchesCentre &&
    (!filterTeachers || filters?.teacherFilter[teacherId]?.show));
};
